import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(
        @Inject(LOCAL_STORAGE) private localStorage: any,
        @Inject(PLATFORM_ID) private platformId,
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        return this.verifyLogin(url);
    }

    verifyLogin(url): boolean {
        const loggedIn = this.isLoggedIn();
        if (!loggedIn) {
            this.router.navigate(['/login']);
            return false;
        } else {
            return true;
        }
    }
    public isLoggedIn(): boolean {
        if (isPlatformBrowser(this.platformId)) {
            const loggedUser = this.localStorage.getItem('token');
            if (loggedUser) {
                return true;
            } else {
                return false;
            }
        }
        return true;
    }

}

@Injectable()
export class NoAuthGuard implements CanActivate {
    constructor(@Inject(LOCAL_STORAGE) private localStorage: any, private router: Router) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        return this.verifyLogin(url);
    }

    verifyLogin(url): boolean {
        const loggedIn = this.isLoggedIn();
        if (loggedIn) {
            this.router.navigate(['']);
            return false;
        } else {
            return true;
        }
    }
    
    public isLoggedIn(): boolean {
        const loggedUser = this.localStorage.getItem('token');
        if (loggedUser) {
            return true;
        } else {
            return false;
        }
    }
}

